import React, { Component } from "react";
import { Card, Container, Button, InputGroup } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faPlusCircle, faRecycle, faSlash, faUserEdit } from "@fortawesome/free-solid-svg-icons";

import UserGrid from "./UserGrid.jsx";
import ModalUserDialog from "./ModalUserDialog";

import GlasschainUsersHttpClient from "providers/http/GlasschainUsersHttpClient";
import AuthService from "providers/auth/AuthService.js";
import GlasschainMsaHttpClient from "providers/http/GlasschainMsaHttpClient.js";

const DelSwal = withReactContent(Swal);


export default class UserPanel extends Component {
  constructor(props) {
    super(props);

    //this.localDataService = new LocalDataService();
    this.httpClient = new GlasschainUsersHttpClient();

    this.syncTimer = null;

    //"msacc" "msauser" "msaadmin" 
    this.selectableScopes = [{value: "msauser", label: "MRA User"}, {value: "msaadmin", label:"MRA Admin"}];

    this.scopeDependents = [
      {parentScope: "msauser", dependentScopes: ["msauser", "msacoreapi", "notificationapi"]},
      {parentScope: "msaadmin", dependentScopes: ["msaadmin", "msacc"]}
    ]

    this.state = {
      editMode: "add",
      userData: null,
      currentUser: null,
      activeStatus: null,
      isLoadingGrid: false,
      orgLocations: []
    };

    this.refreshData = this.refreshData.bind(this);
    this.onRowSelectChange = this.onRowSelectChange.bind(this);
    this.onNewRequest = this.onNewRequest.bind(this);
    this.onEditRequest = this.onEditRequest.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);

    this.msaHttpClient = new GlasschainMsaHttpClient();
    this.auth = new AuthService();

    this.closeNewModal = this.closeNewModal.bind(this);
    this.postNew = this.postNew.bind(this);
    this.postUpdated = this.postUpdated.bind(this);
    this.onDeleteRequest = this.onDeleteRequest.bind(this);
    this.onBtnToggleRetireSelectedUser = this.onBtnToggleRetireSelectedUser.bind(this);

  }

  async componentDidMount() {
    await this.refreshData();
    var gcid = this.auth.getGcid();
    var locationsCatalog = await this.msaHttpClient.fetchMasterCatalog(gcid, "warehousescatalog");
    var locations = locationsCatalog.warehouses.map(l =>{
      return {id: l.warehouse.id, value: l.warehouse.id, label:l.warehouse.name}
    });
    if(locations){
      this.setState({
        orgLocations: locations
      })
    }
  }




  async refreshData() {
    this.setState({ isLoadingGrid: true });
    var gridDataResponse = await this.httpClient.fetchUserList();
    var dataResult = gridDataResponse.data;
    //var dataResult = await this.coreService.fetchSubscribers();
    console.log("User Data:");
    console.info(dataResult);
    this.setState({
      userData: dataResult,
      selectedRow: null, // reset
      isLoadingGrid: false,
      syncing: false
    });
  }



  onRowSelectChange(newSelectedRow) {
    console.log("OnRowSelectChange");
    console.log("set state for selectedRow");
    console.info(newSelectedRow);
    var newActiveStatus = newSelectedRow.enabled;
    this.setState({ 
      currentUser: newSelectedRow,
      activeStatus: newActiveStatus
     });
  }

  onNewRequest() {
    this.setState({
      editMode: "add",
      showNewSubModal: true
    });
  }

  onEditRequest() {
    if (!this.state.currentUser) {
      DelSwal.fire({ icon: "error", title: "Edit User", text: "Select a user first!" });
      return;
    }
    this.setState({
      editMode: "update",
      showNewSubModal: true
    });
  }

  closeNewModal() {
    this.setState({ showNewSubModal: false })
  }

  async postNew(user) 
  {
    var allowedScopes = [];
    for (var i=0; i<user.scopes.length; i++)
    {
      var parentScope = user.scopes[i];
      var dependentScopes = this.scopeDependents.find(s => s.parentScope === parentScope).dependentScopes;
      allowedScopes = allowedScopes.concat(dependentScopes);
    }
    user.scopes = allowedScopes;
    
    var result = await this.httpClient.postAddUser("", user);
    this.closeNewModal();
    toast.success("New user " + user.name + " has been added.");
    await this.refreshData();
  }



  async postUpdated(user) {
    var allowedScopes = [];
    for (var i=0; i<user.scopes.length; i++)
    {
      var parentScope = user.scopes[i];
      var dependentScopes = this.scopeDependents.find(s => s.parentScope === parentScope).dependentScopes;
      allowedScopes = allowedScopes.concat(dependentScopes);
    }
    user.scopes = allowedScopes;
    var result = await this.httpClient.postUpdateUser("", user);
    this.closeNewModal();
    toast.success("user " + user.name + " has been updated.");
    await this.refreshData();
  }

  async onDeleteRequest() {
    if (!this.state.currentUser) {
      DelSwal.fire({ icon: "error", title: "Remove User", text: "Select a user to remove first!" });
      return;
    }
    DelSwal.fire
      (
        {
          icon: "question",
          title: "Remove User?",
          text: "Confirm you want to permanently remove the existing user " + this.state.currentUser.clientName,
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel"
        }
      ).then(async (result) => {
        if (result.value) {
          await this.httpClient.deleteUser(this.gcid, this.state.currentUser.clientId);
          await this.refreshData();
          var currentUserName = this.state.currentUser.clientName;
          this.setState({ currentUser: null});
          return DelSwal.fire({icon: "success", text: currentUserName + " has been permanently deleted."});
        }
      }
      );
  }

  async onBtnToggleRetireSelectedUser(){
    var statusWord = (this.state.activeStatus) ? "retire": "activate";
    if (!this.state.currentUser) {
      DelSwal.fire({ icon: "error", title: "Toggle User", text: "Select a user first!" });
      return;
    }
    var userId = this.state.currentUser.clientId;
    DelSwal.fire({
      icon: "question",
      title: statusWord + " User?",
      text: "Confirm you want to " + statusWord + " user " + userId,
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel"
    })
    .then ( async (result) =>{
      if (result.value){
        await this.httpClient.postUpdateUserEnabledFlag(this.gcid, userId, !this.state.activeStatus);
        await this.refreshData();
        this.setState({ currentUser: null});
        return DelSwal.fire({icon: "success", text: userId + " has been " + statusWord + "d."});
    }
  });
}



  render() {

    const loadingGridIcon = this.state.isLoadingGrid ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );


    return (
      <div id="admin-panel">

        <div>
          <ModalUserDialog
            showNewModal={this.state.showNewSubModal}
            closeNewModal={this.closeNewModal}
            postNew={this.postNew}
            postUpdated={this.postUpdated} 
            userSession={this.props.userSession}
            editMode={this.state.editMode}
            currentUser={this.state.currentUser}
            scopes={this.selectableScopes}
            gridData = {this.state.userData}
            locationList = {this.state.orgLocations}
          />
        </div>

        <h3 style={{ color: "black", marginLeft: "10px" }}>User Maintenance</h3>

        <div id="adminselectionui">

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.onNewRequest}
          >
            <FontAwesomeIcon icon={faPlusCircle} />
            &nbsp;New
          </Button>

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.onEditRequest}
          >
            <FontAwesomeIcon icon={faUserEdit} />
            &nbsp;Edit
          </Button>

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.onBtnToggleRetireSelectedUser}
          >
             <FontAwesomeIcon icon={(this.state.activeStatus) ? "umbrella-beach" : "user-clock"} />
            &nbsp;{(this.state.activeStatus) ? "Retire": "Activate"}
          </Button>

          <Button
            size="sm"
            variant="outline-info"
            onClick={this.onDeleteRequest}
          >
            <FontAwesomeIcon icon={faSlash} />
            &nbsp;Delete
          </Button>


          <Button
            size="sm"
            variant="outline-info"
            onClick={this.refreshData}
          >
            <FontAwesomeIcon icon={faRecycle} />
            &nbsp;Refresh
          </Button>

          <span style={{ float: "right", paddingLeft: "20px", paddingRight: "20px" }}>{loadingGridIcon}</span>
        </div>

        <div style={{ width: "100%", height: "100%" }}>
          <UserGrid
            rowData={this.state.userData}
            onRowSelectChange={this.onRowSelectChange}
            onEditRequest={this.onEditRequest}
          />
        </div>

      </div>
    );
  }
}
